import { useTranslation } from "react-i18next";
import { Plane } from "lucide-react";
import { AuthPage } from "@tabipla/components";
import { useAuth } from "@/application/hooks/useAuth";

const TABITTO_THEME = {
  iconBg: "bg-primary",
  iconText: "text-primary-foreground",
  buttonClass: "",
  backgroundGradient: "from-primary/5 via-background to-primary/10",
};

export function RegisterPage() {
  const { t } = useTranslation();
  const { register, loginWithLine, isLoading } = useAuth();

  return (
    <AuthPage
      appName="Tabitto"
      tagline={t("app.tagline", "旅行計画をもっと楽しく")}
      icon={<Plane className="h-8 w-8" />}
      theme={TABITTO_THEME}
      mode="register"
      onRegister={register}
      onLoginWithLine={loginWithLine}
      isLoading={isLoading}
    />
  );
}
